import request from './request'

// 获取已发布的公告（客户端）
export function getPublishedAnnouncements() {
  return request({
    url: '/api/announcements/published',
    method: 'get'
  })
}

